import { createSelector } from 'reselect'

import { EMPTY_OBJECT } from 'utils/emptyConstants'

import { PLAN_TYPES } from 'containers/App/constants'
import { selectActualFeatureFlags, selectActualLicenses } from 'containers/App/selectors'

// The awarenessCenter slice is injected per-route (store.replaceReducer in
// components/pages/awareness-center/index.js) and dropped again when another
// route injects its own data layer; selectors can still run in that window
// (mounted subscriptions, in-flight epics), so the slice must be read null-safely.
const selectCampaigns = (state) => state.awarenessCenter?.campaigns ?? EMPTY_OBJECT

const selectCampaignsLoader = (state) => selectCampaigns(state).campaignsLoader
export const selectRecommendedCampaignsLoader = (state) =>
  selectCampaigns(state).recommendedCampaignsLoader
const selectError = (state) => selectCampaigns(state).error
const selectData = (state) => selectCampaigns(state).data
const selectStatusFilter = (state) => selectCampaigns(state).statusFilter
const selectLaunchTypeFilter = (state) => selectCampaigns(state).launchTypeFilter
const selectDateFilter = (state) => selectCampaigns(state).dateFilter
const selectMessage = (state) => selectCampaigns(state).message
const selectLanguagesFilter = (state) => selectCampaigns(state).languagesFilter
const selectCampaignTypeFilter = (state) => selectCampaigns(state).campaignTypeFilter
const selectCampaignsSearchFilter = (state) => selectCampaigns(state).search
const selectPage = (state) => selectCampaigns(state).page
const selectSortProperty = (state) => selectCampaigns(state).sortProperty
const selectRecommendedCampaigns = (state) => selectCampaigns(state).recommendedCampaigns
const selectSelectionData = (state) => selectCampaigns(state).selectionData
const selectRecommendedPreviewData = (state) => selectCampaigns(state).recommendedPreviewData
const selectMainLoader = createSelector(
  selectCampaignsLoader,
  selectRecommendedCampaignsLoader,
  (campaignsLoader, recommendedCampaignsLoader) => campaignsLoader && recommendedCampaignsLoader
)

const selectIsIneligibleAutonomousCampaignsAccount = createSelector(
  selectActualFeatureFlags,
  selectActualLicenses,
  (ff, licenses) =>
    !ff.AUTONOMOUS_CAMPAIGNS &&
    ![PLAN_TYPES.SAT_SUITE, PLAN_TYPES.COMPLETE_PROTECT].includes(licenses.plan)
)

export {
  selectError,
  selectData,
  selectStatusFilter,
  selectDateFilter,
  selectLanguagesFilter,
  selectCampaignTypeFilter,
  selectCampaignsSearchFilter,
  selectPage,
  selectMessage,
  selectSortProperty,
  selectRecommendedCampaigns,
  selectRecommendedPreviewData,
  selectMainLoader,
  selectCampaignsLoader,
  selectIsIneligibleAutonomousCampaignsAccount,
  selectSelectionData,
  selectLaunchTypeFilter,
}
